/**
 * Shared avatar-identity helpers — ONE deterministic colour + initials
 * treatment for a user across every surface (top bar, versions page,
 * profile page), keyed by their stable identity string (identifier or
 * email). Same key → same hue everywhere, so a user is recognisable by
 * colour even when their image hasn't loaded (user 2026-08-29: top bar,
 * versioning and profile each showed a different fallback colour).
 */

export function actorHue(key: string): number {
  let hash = 0;
  for (const ch of key) hash = (hash * 31 + ch.charCodeAt(0)) >>> 0;
  return hash % 360;
}

export function actorColor(key: string): string {
  return `hsl(${actorHue(key)}deg 55% 45%)`;
}

export function actorInitials(key: string): string {
  return (
    key
      .split("@")[0]
      .split(/[._-]/)
      .map((p) => p[0]?.toUpperCase() ?? "")
      .join("")
      .slice(0, 2) || "?"
  );
}
